import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PodcastList from '../components/PodcastList';
import PodcastDetail from './PodcastDetail';

const Listens = () => {
  return (
    <Routes>
      <Route
        index
        element={(
          <section aria-labelledby="listens-heading">
            <h2 id="listens-heading" className="section-header">Listens</h2>
            <PodcastList />
          </section>
        )}
      />
      <Route path=":id" element={<PodcastDetail headingLevel={2} />} />
    </Routes>
  );
};

export default Listens;
